export const getObject = (option, typeCode, dropDownData) => {
  const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
  let label = {};
  options &&
    options.length > 0 &&
    options.forEach((item) => {
      if (item.valueCode === option) {
        label = item;
      }
    });
  return label;
};

export const getMultipleObject = (option, typeCode, dropDownData) => {
  const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
  const values = [];
  if (options && options.length > 0) {
    options.forEach((item) => {
      option.forEach((item2) => {
        if (item.valueCode === item2) {
          values.push(item);
        }
      });
    });
  }
  return values;
};

export const getValueCode = (options) => {
  const values = [];
  if (options && options.length > 0) {
    options.forEach((item) => {
      values.push(item.clientCode);
    });
  }
  return values;
};

export const getValueObject = (option, typeCode, dropDownData) => {
  const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];

  let label = {};
  options &&
    options.length > 0 &&
    options.forEach((item) => {
      if (item.value == option) {
        label = item;
      }
    });

  return label;
};

export const getUDWObject = (options, option) => {
  let label = {};
  options &&
    options.length > 0 &&
    options.forEach((item) => {
      if (item === option) {
        label = {key: item, value: item};
      }
    });
  return label;
};
